// third-party
import { configureStore } from '@reduxjs/toolkit';
import { useDispatch as useAppDispatch, useSelector as useAppSelector, TypedUseSelectorHook } from 'react-redux';

// project imports
import { registerLogoutHandler, invalidateSessionCaches } from '@/services/auth-session';
import reducer from './reducer';
import { logout } from './slices/auth';

// ==============================|| REDUX - MAIN STORE ||============================== //

const store = configureStore({
    reducer
});

registerLogoutHandler(() => {
    invalidateSessionCaches();
    store.dispatch(logout());
});

export type RootState = ReturnType<typeof reducer>;

export type AppDispatch = typeof store.dispatch;

const { dispatch } = store;

const useDispatch = () => useAppDispatch<AppDispatch>();
const useSelector: TypedUseSelectorHook<RootState> = useAppSelector;

export { store, dispatch, useSelector, useDispatch };
